import React from 'react';
import Button from '@dbk/ui-buttons';

const TradeCTAButton = (props) => {
  const { className, message, handleClick, fetchInProgress , tertiary, secondary, disabled,value} = props;

  return (
  <div className="security-list-item-cta">
        <Button
            className={className}
            testID={`btn_trade_search_cta_${value}_test`}
            accessibilityLabel={`btn_trade_search_cta_${value}_test`}
            onPress={() => handleClick()}
            size={'large'}
            loading={fetchInProgress}
            tertiary={tertiary}
            secondary={secondary}
            disabled={disabled}>
            {message}
          </Button>
    </div>
      )
  }

export default TradeCTAButton;
